import { Flex, Layout, Typography } from 'antd';
import { OrderIcon } from './OrderOverviewSection';

interface OrderSummaryCardsProps {
  title: string;
  value: number;
  Icon: OrderIcon;
  itemLength: number;
}

const { Text } = Typography;

const OrderSummaryCards = ({ title, value, Icon, itemLength }: OrderSummaryCardsProps) => {
  const iconColor = Icon?.color ?? '#888';
  const IconComponent = Icon?.icon;

  return (
    <Layout className='max-w-[calc(50%-.5rem)] min-w-[calc(16.6%-2.5rem)] w-full p-3 flex flex-row flex-wrap gap-1 items-center justify-between bg-white rounded-[10px] shadow-card-dark'>
      <Flex gap={'.25rem'} align='center' className='mt-1'>
        <Flex
          align='center'
          justify='center'
          className='w-8 h-8 rounded-full'
          style={{ backgroundColor: iconColor + '15' }}
        >
          {IconComponent ? <IconComponent width={16} height={16} color={iconColor} /> : null}
        </Flex>
        <Text className='text-sm font-base'>{title}</Text>
      </Flex>
      <Flex justify='end' className={itemLength > 2 ? 'w-full' : ''}>
        <Text className='text-xl font-medium'>{value}</Text>
      </Flex>
    </Layout>
  );
};

export default OrderSummaryCards;
